import keyMirror from 'helpers/keymirror';
import { generateActionName } from 'helpers/strings';

const UPDATE_OCCUPATION = generateActionName('rekyc', 'UPDATE_OCCUPATION');

const UPDATE_POLITICALLY_EXPOSED = generateActionName(
  'rekyc',
  'UPDATE_POLITICALLY_EXPOSED'
);

const UPDATE_ANNUAL_INCOME = generateActionName('rekyc', 'UPDATE_ANNUAL_INCOME');

const UPDATE_REKYC_MODAL_STATE = generateActionName('rekyc', 'OPEN_REKYC_MODAL');

const UPDATE_RESTRICTION_INFO_MODAL = generateActionName(
  'rekyc',
  'UPDATE_RESTRICTION_INFO_MODAL'
);

const actionTypes = keyMirror({
  [generateActionName('rekyc', 'GET_PROFILE_KYC_DETAILS')]: null,
  [generateActionName('rekyc', 'HYPERVERGE_KYC_CONFIG')]: null,
  [generateActionName('rekyc', 'UPDATE_ADDRESS_CONFIG')]: null,
  [generateActionName('rekyc', 'GET_REKYC_FLOW')]: null,
});

export {
  UPDATE_OCCUPATION,
  UPDATE_POLITICALLY_EXPOSED,
  UPDATE_ANNUAL_INCOME,
  UPDATE_REKYC_MODAL_STATE,
  UPDATE_RESTRICTION_INFO_MODAL,
  actionTypes,
};
